<!-- Company selection -->
<div
  id="wf-company-selection"
  [ngClass]="{
       'tw-bg-gray-800 tw-p-4 tw-rounded-md tw-mb-8 @md:tw-w-full': !compactMode,
       'tw-bg-transparent tw-p-0': compactMode
     }">
  <div
    class="tw-flex tw-justify-between tw-flex-wrap tw-gap-y-2"
    [ngClass]="{ 'tw-mb-4': !compactMode, 'tw-mb-2': compactMode }">
    <!-- List Status name & actions -->
    <div class="tw-flex tw-items-center tw-gap-3" *ngIf="!compactMode">
      <div class="tw-text-gray-300 tw-flex tw-items-center tw-gap-2">
        <ng-container *ngIf="activeList && activeList.id !== null && !isEditingName">
          <mat-icon class="tw-text-gray-400 tw-text-base tw-w-[18px] tw-hidden @md:tw-block">
            folder
          </mat-icon>
          <span class="tw-text-gray-100 tw-font-semibold tw-text-sm">
            {{ activeList.name }}
          </span>
          <span *ngIf="isListModified" class="tw-text-amber-400 tw-ml-1 tw-text-xs">
            (Modified)
          </span>
          <button
            mat-icon-button
            class="edit-existing-list-btn tw-text-teal-400/80 hover:tw-bg-teal-500/20 tw-transition-all"
            (click)="startEditingName()">
            <mat-icon class="tw-text-[1.3rem] tw-leading-[1.3rem]">edit</mat-icon>
          </button>
        </ng-container>
        <ng-container *ngIf="!activeList || activeList.id === null || isEditingName">
          <div class="tw-flex tw-items-center tw-gap-2">
            <ng-container *ngIf="!isEditingName; else nameEditField">
              <button
                mat-icon-button
                class="edit-new-list-btn tw-text-teal-400/80 -tw-mr-2 hover:tw-bg-teal-500/20 tw-transition-all tw-mb-1"
                (click)="startEditingName()">
                <mat-icon class="tw-text-base">edit</mat-icon>
              </button>
              <span class="tw-italic tw-text-gray-400">
                {{ activeList?.name || 'Untitled Company List' }}
              </span>
            </ng-container>
            <ng-template #nameEditField>
              <mat-form-field id="list-name-edit-field" class="tw-w-48 -tw-mb-5">
                <mat-label>Enter list name</mat-label>
                <input
                  matInput
                  #nameInput
                  [(ngModel)]="listNameEdit"
                  (keyup.enter)="saveListName()"
                  (keyup.escape)="cancelEditingName()"
                  placeholder="e.g. New Startup List" />
              </mat-form-field>
              <button
                mat-icon-button
                class="tw-text-teal-400 tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center tw-p-0"
                (click)="saveListName()">
                <mat-icon>check</mat-icon>
              </button>
              <button
                mat-icon-button
                class="tw-text-gray-400 tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center tw-p-0"
                (click)="cancelEditingName()">
                <mat-icon>close</mat-icon>
              </button>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- buttons -->
    <div class="tw-flex tw-items-center tw-gap-2" *ngIf="!compactMode">
      <!-- Action buttons for desktop -->
      <div class="tw-hidden @mdx:tw-flex tw-items-center tw-gap-2">
        <!-- For any list with companies -->
        <button
          *ngIf="activeList.companies.length > 0"
          mat-stroked-button
          color="primary"
          (click)="saveAsNewList()"
          class="tw-bg-teal-500/25">
          <span class="tw-flex tw-items-center tw-gap-2">
            <mat-icon class="tw-text-base tw-w-[18px]">add</mat-icon>
            Save as New List
          </span>
        </button>
        <!-- Only when a user's own list is modified -->
        <button
          *ngIf="activeList && activeList.id !== null && isListModified && activeList.scope !== 'public'"
          mat-stroked-button
          color="primary"
          (click)="saveList()"
          class="tw-bg-teal-500/25">
          <span class="tw-flex tw-items-center tw-gap-2">
            <mat-icon class="tw-text-base tw-w-[18px]">save</mat-icon>
            Save Changes
          </span>
        </button>

        <button mat-stroked-button (click)="openSavedListsDialog()" color="primary">
          <span class="tw-flex tw-items-center tw-gap-2">
            <mat-icon class="tw-text-base tw-w-[18px]">folder_open</mat-icon>
            Load Saved List
          </span>
        </button>
      </div>

      <!-- Action buttons for mobile -->
      <button
        [matMenuTriggerFor]="menu"
        class="@mdx:tw-hidden tw-p-2 tw-rounded-full tw-text-gray-100 tw-transition-colors tw-bg-gray-700 hover:tw-bg-gray-600">
        <mat-icon class="tw-align-middle">more_vert</mat-icon>
      </button>

      <!-- Action buttons dropdown menu for mobile -->
      <mat-menu #menu="matMenu">
        <button mat-menu-item *ngIf="activeList.companies.length > 0" (click)="saveAsNewList()">
          <mat-icon>add</mat-icon>
          <span>Save as New List</span>
        </button>
        <button
          mat-menu-item
          *ngIf="activeList && activeList.id !== null && isListModified && activeList.scope !== 'public'"
          (click)="saveList()">
          <mat-icon>save_outline</mat-icon>
          <span>Save Changes</span>
        </button>
        <button mat-menu-item (click)="openSavedListsDialog()">
          <mat-icon>folder_open</mat-icon>
          <span>Load Saved List</span>
        </button>
      </mat-menu>

      <button
        *ngIf="activeList.companies.length > 0"
        (click)="clearList()"
        class="@md:tw-hidden tw-p-2 tw-rounded-full tw-text-red-400 tw-transition-colors tw-bg-gray-700 hover:tw-bg-gray-600">
        <mat-icon class="tw-align-middle">delete_outline</mat-icon>
      </button>

      <button
        mat-stroked-button
        color="warn"
        *ngIf="activeList.companies.length > 0"
        (click)="clearList()"
        class="tw-hidden @md:tw-block">
        <span class="tw-flex tw-items-center tw-gap-2 tw-text-red-400">
          <mat-icon class="tw-text-base tw-w-[18px]">delete_outline</mat-icon>
          Clear List
        </span>
      </button>
    </div>
  </div>

  <!-- Company selection & edit mode -->
  <div
    [ngClass]="{ 'tw-bg-gray-700 tw-p-4 tw-rounded-md tw-border tw-border-dashed tw-border-gray-500 tw-mt-3': editMode || activeList.companies.length === 0 }">
    <div *ngIf="isLoadingList" class="tw-flex tw-justify-center tw-items-center tw-py-8">
      <mat-spinner diameter="24"></mat-spinner>
      <span class="tw-ml-3 tw-text-gray-400">Loading company list...</span>
    </div>

    <ng-container *ngIf="!isLoadingList">
      <div class="tw-flex tw-w-full tw-items-center tw-flex-row">
        <div
          class="tw-flex tw-flex-wrap"
          [ngClass]="{ 'tw-gap-x-3 tw-gap-y-6': editMode, 'tw-gap-3': !editMode }">
          <button
            *ngFor="let company of activeList.companies"
            (click)="allowSelection && toggleCompanySelection(company, $event)"
            class="tw-px-4 tw-py-2 tw-rounded-md tw-transition-colors tw-font-medium tw-text-sm tw-max-h-10"
            [ngClass]="{
                    'tw-bg-[#7FFFD4] tw-text-black': isCompanySelected(company.id!) && allowSelection,
                    'tw-bg-gray-600 tw-text-white tw-border-2 tw-border-solid tw-border-teal-400': !isCompanySelected(company.id!) && allowSelection,
                    'tw-bg-gray-700 tw-text-gray-300': !allowSelection,
                    'tw-flex tw-items-center tw-gap-2': (editMode || activeList.companies.length === 0) && !readOnly,
                    'tw-cursor-pointer': allowSelection,
                    'tw-cursor-default': !allowSelection
                  }">
            {{ company.name }}
            <button
              *ngIf="(editMode || activeList.companies.length === 0) && !readOnly"
              class="icon-btn tw-text-dark-light-dynamic tw-transition-all -tw-mr-4"
              (click)="removeCompanyFromList(company)">
              <mat-icon
                class="close-icon tw-inline-block tw-text-base tw-leading-[26px] tw-font-semibold"
                [ngClass]="{ 'tw-text-gray-800': isCompanySelected(company.id!)}">
                clear
              </mat-icon>
            </button>
          </button>
          <p
            *ngIf="editMode && activeList.companies.length >= maxCompanies"
            class="tw-ml-3 tw-text-sm tw-text-gray-400 tw-mt-0 tw-flex-wrap tw-mb-3 @md:tw-mb-0">
            Max # of companies reached.<br />
            Remove some to add more.
          </p>
          <app-company-search
            *ngIf="!readOnly && activeList.companies.length < maxCompanies && (editMode || activeList.companies.length === 0)"
            resetAfterSelection="true"
            [labelText]="'Add a company'"
            [floatLabel]="'always'"
            (companySelected)="companyPickedInSearch($event)"
            class="moneyball-battle-search" />
        </div>

        <button
          *ngIf="!readOnly && activeList.companies.length > 0"
          (click)="toggleEditMode()"
          class="tw-ml-3 tw-p-2 tw-rounded-full tw-text-white tw-transition-colors"
          [ngClass]="{
                  'tw-bg-gray-600 hover:tw-bg-gray-500': editMode,
                  'tw-bg-gray-700 hover:tw-bg-gray-600': !editMode
                }">
          <mat-icon class="tw-align-middle">{{ editMode ? 'done' : 'edit' }}</mat-icon>
        </button>
      </div>

      <div
        *ngIf="!readOnly && !compactMode && editMode && activeList.companies.length < maxCompanies">
        <p class="tw-text-sm tw-text-gray-400 tw-mt-4 tw-mb-0 tw-flex tw-items-center tw-gap-4">
          Suggested Companies:

          <span *ngIf="suggestedCompanies === null" class="tw-inline-block">
            <mat-spinner diameter="20"></mat-spinner>
          </span>

          <span *ngIf="suggestedCompanies !== null" class="tw-flex tw-flex-wrap tw-gap-2">
            <a
              *ngFor="let company of suggestedCompanies"
              (click)="companyPickedInSearch(company)"
              href="javascript:void(0)"
              class="tw-font-medium tw-text-sm tw-transition-all hover:tw-decoration-[2px] hover:tw-underline hover:tw-underline-offset-4
                      tw-flex tw-items-center tw-gap-1 tw-group">
              {{ company.company.name }}

              <mat-icon
                class="close-icon tw-inline-block tw-text-base tw-leading-[26px] tw-font-semibold tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity">
                add
              </mat-icon>
            </a>
          </span>
        </p>
      </div>
      <!-- Select Multiple Companies checkbox -->
      <div
        *ngIf="multiSelect === 'toggle'"
        class="tw-flex tw-items-center tw-gap-2 tw-mt-4 tw-text-gray-400 tw-text-sm">
        <mat-checkbox
          [(ngModel)]="selectMultipleCompanies"
          (change)="onSelectMultipleCompaniesChange($event)">
          Combine Multiple Companies for Analysis
        </mat-checkbox>
      </div>
    </ng-container>
  </div>
</div>
